import { render, staticRenderFns } from "./AnswerSheetResultsBySubjectPage.vue?vue&type=template&id=61980b36&scoped=true&"
import script from "./AnswerSheetResultsBySubjectPage.vue?vue&type=script&lang=js&"
export * from "./AnswerSheetResultsBySubjectPage.vue?vue&type=script&lang=js&"
import style0 from "./AnswerSheetResultsBySubjectPage.vue?vue&type=style&index=0&id=61980b36&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61980b36",
  null
  
)

export default component.exports